<template>
  <div class="results-feedback-block" @click="toggleExpand">
    <div>
      <div class="results-feedback-block-interior">
        <div v-if="position === '1'">
          <img class="results-feedback-block-medal" alt="" src="/images/resultsV2/medal_1.svg" />
        </div>
        <div v-else-if="position === '2'">
          <img class="results-feedback-block-medal" alt="" src="/images/resultsV2/medal_2.svg" />
        </div>
        <div v-else-if="position == '3'">
          <img class="results-feedback-block-medal" alt="" src="/images/resultsV2/medal_3.svg" />
        </div>
        <div class="results-feedback-block-right">
          <b class="results-feedback-block-title">{{getTitle()}}
            <b :class="'results-feedback-block-title-top10' + getGradeColour()" v-if="top10">top 10%</b>
          </b>
          <div class="results-feedback-block-text">
            <div :class="isExpanded ? ' ' : 'results-feedback-block-text-short'">
              {{getText()}}
            </div>
            <div v-if="!isExpanded">
              <i class="results-feedback-block-expand">{{$t('candidate_profiles.discover_more')}}</i>
            </div>
          </div>
        </div>
        <div v-if="isExpanded">
          <img class="results-feedback-block-expand-icon" alt="" src="@/assets/images/icon/arrow_up.svg" />
        </div>
        <div v-else>
          <img class="results-feedback-block-expand-icon" alt="" src="@/assets/images/icon/arrow_down.svg" />
        </div>
      </div>
      <div v-if="isExpanded">
        <div class="module-laboratory">
          <div class="module-block-title">Le mot du labo</div>
          <p class="quote">
            <span class="quote-icon"></span> 
            {{getLaboText()}}
            <span class="quote-icon end"></span>
          </p>
        </div>
        <div class="module-advantages">
          <div class="module-block-title">  {{getAvantageTitle()}} </div>
          <div class="list-items">
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon" :class="getAvantageIcon1()"></i></div>
              <div class="description"> {{getAvantageText1()}} </div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon" :class="getAvantageIcon2()"></i></div>
              <div class="description">{{getAvantageText2()}}</div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon" :class="getAvantageIcon3()"></i></div>
              <div class="description">{{getAvantageText3()}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['skill', 'position', 'top10'],
  data() {
    return {
      isExpanded: false
    };
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    getTitle() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "Gestion du stress";
          break;
        case 'adaptability':
          text += "Adaptabilité";
          break;
        case 'pb_solving':
          text += "Résolution de problèmes";
          break;
        case 'auto_efficient':
          text = "Confiance en ses compétences";
          break;
        case 'active_listen':
          text += "Ecoute active";
          break;
        case 'empathy':
          text += "Empathie";
          break;
        case 'time_manage':
          text = "Gestion du temps";
          break;
        case 'planning':
          text += "Planification";
          break;
        case 'decisions':
          text += "Prise de décision";
          break;
        default:
          break;
      }
      return text;
    },
    getText() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "Équilibre, résilience, sérénité, la gestion du stress permet de maintenir un niveau de performance constant pour exceller sous pression.";
          break;
        case 'adaptability':
          text += "Flexibilité, réactivité, anticipation, l’adaptabilité permet d’évoluer avec aisance dans un environnement changeant.";
          break;
        case 'pb_solving':
          text += "Raisonnement, logique, projection, la résolution de problèmes permet de surmonter les défis complexes avec des solutions adaptées. ";
          break;
        case 'auto_efficient':
          text = "Assurance, reconnaissance de sa valeur, la confiance en ses compétences permet de s'affirmer professionnellement.";
          break;
        case 'active_listen':
          text += "Attention, compréhension, réceptivité, l'écoute active permet de capter et comprendre les messages d'autrui.";
          break;
        case 'empathy':
          text += "Compréhension émotionnelle, bienveillance, l'empathie permet de se connecter aux autres et de comprendre leurs perspectives.";
          break;
        case 'time_manage':
          text = "Organisation, priorisation, efficacité, la gestion du temps permet d'optimiser sa productivité.";
          break;
        case 'planning':
          text += "Organisation, anticipation, structuration, la planification permet d'optimiser la réalisation des projets et objectifs.";
          break;
        case 'decisions':
          text += "Analyse, jugement, détermination, la prise de décision permet d'agir de manière réfléchie et efficace.";
          break;
        default:
          break;
      }
      return text;
    },
    getLaboText() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "Savoir gérer son stress, c'est garder le contrôle de soi pour agir efficacement face à des situations de tension. C’est une compétence clé pour la plupart des postes où il faut savoir garder une approche rationnelle malgré un environnement qui peut être stressant.";
          break;
        case 'adaptability':
          text += "Être adaptable, c’est reconnaître et accepter le changement et revoir ses méthodes de travail si celles-ci ne collent plus au contexte. Dans un monde en mouvement constant, c’est une compétence clé pour évoluer de façon sereine dans un cadre professionnel.";
          break;
        case 'pb_solving':
          text += "Résoudre des problèmes, c’est la capacité à identifier et à traiter efficacement les problèmes ou les défis auxquels on est confronté. C'est une compétence essentielle pour comprendre les enjeux d’une situation et prendre des décisions rationnelles.";
          break;
        case 'auto_efficient':
          text = "Avoir confiance en ses compétences, c'est reconnaître sa valeur et oser mettre en avant ses talents. C'est essentiel pour progresser et saisir les opportunités professionnelles.";
          break;
        case 'active_listen':
          text += "Pratiquer l'écoute active, c'est être pleinement présent et attentif aux messages verbaux et non-verbaux de ses interlocuteurs. C'est fondamental pour construire des relations professionnelles de qualité.";
          break;
        case 'empathy':
          text += "Être empathique, c'est comprendre et prendre en compte les émotions et le point de vue des autres. C'est une compétence clé pour le travail en équipe et le leadership.";
          break;
        case 'time_manage':
          text = "Gérer son temps efficacement, c'est savoir prioriser ses tâches et organiser son travail de manière optimale. C'est essentiel pour atteindre ses objectifs tout en maintenant un équilibre.";
          break;
        case 'planning':
          text += "Planifier efficacement, c'est savoir organiser et séquencer les actions nécessaires pour atteindre un objectif. C'est fondamental pour la gestion de projet et l'atteinte des résultats.";
          break;
        case 'decisions':
          text += "Prendre des décisions, c'est savoir analyser une situation et choisir la meilleure option possible en tenant compte des contraintes. C'est une compétence clé pour tout poste à responsabilité.";
          break;
        default:
          break;
      }
      return text;
    },
    getAvantageTitle() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "Les avantages de la gestion du stress";
          break;
        case 'adaptability':
          text += "Les avantages de l'Adaptabilité";
          break;
        case 'pb_solving':
          text += "Les avantages de la Résolution de problèmes";
          break;
        case 'auto_efficient':
          text = "Les avantages de la Confiance en ses compétences";
          break;
        case 'active_listen':
          text += "Les avantages de l'Ecoute active";
          break;
        case 'empathy':
          text += "Les avantages de l'Empathie";
          break;
        case 'time_manage':
          text = "Les avantages de la Gestion du temps";
          break;
        case 'planning':
          text += "Les avantages de la Planification";
          break;
        case 'decisions':
          text += "Les avantages de la Prise de décision";
          break;
        default:
          break;
      }
      return text;
    },
    getAvantageText1() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "Maintenir ses performances en situation de stress";
          break;
        case 'adaptability':
          text += "Reconnaître et accepter le changement";
          break;
        case 'pb_solving':
          text += "Faire preuve d’une capacité d’analyse";
          break;
        case 'auto_efficient':
          text = "Oser prendre des initiatives";
          break;
        case 'active_listen':
          text += "Améliorer la qualité des échanges";
          break;
        case 'empathy':
          text += "Créer des relations de confiance";
          break;
        case 'time_manage':
          text = "Augmenter sa productivité";
          break;
        case 'planning':
          text += "Optimiser les ressources";
          break;
        case 'decisions':
          text += "Gagner en autonomie";
          break;
        default:
          break;
      }
      return text;
    },
    getAvantageText2() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "Être à l’aise dans des situations de tension";
          break;
        case 'adaptability':
          text += "Saisir les opportunités";
          break;
        case 'pb_solving':
          text += "Définir un plan pour atteindre un objectif";
          break;
        case 'auto_efficient':
          text = "Se positionner comme expert";
          break;
        case 'active_listen':
          text += "Renforcer la confiance";
          break;
        case 'empathy':
          text += "Améliorer la collaboration";
          break;
        case 'time_manage':
          text = "Réduire le stress";
          break;
        case 'planning':
          text += "Réduire les risques";
          break;
        case 'decisions':
          text += "Améliorer l'efficacité";
          break;
        default:
          break;
      }
      return text;
    },
    getAvantageText3() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "Savoir travailler sous contrainte";
          break;
        case 'adaptability':
          text += "Être en capacité de sortir de sa zone de confort";
          break;
        case 'pb_solving':
          text += "Être en capacité de résoudre un problème seul";
          break;
        case 'auto_efficient':
          text = "Développer son leadership";
          break;
        case 'active_listen':
          text += "Mieux comprendre les besoins";
          break;
        case 'empathy':
          text += "Faciliter la résolution de conflits";
          break;
        case 'time_manage':
          text = "Atteindre ses objectifs plus facilement";
          break;
        case 'planning':
          text += "Améliorer la performance";
          break;
        case 'decisions':
          text += "Développer sa crédibilité";
          break;
        default:
          break;
      }
      return text;
    },
    getAvantageIcon1() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "chart_icon_V2";
          break;
        case 'adaptability':
          text += "path_icon_V2";
          break;
        case 'pb_solving':
          text += "microscope_icon_V2";
          break;
        case 'auto_efficient':
          text = "pen_icon_V2";
          break;
        case 'active_listen':
          text += "hand-care_icon_V2";
          break;
        case 'empathy':
          text += "influence_icon_V2";
          break;
        case 'time_manage':
          text = "productivity_icon_V2";
          break;
        case 'planning':
          text += "box_icon_V2";
          break;
        case 'decisions':
          text += "user_icon_V2";
          break;
        default:
          break;
      }
      return text;
    },
    getAvantageIcon2() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "bell_icon_V2";
          break;
        case 'adaptability':
          text += "rocket_icon_V2";
          break;
        case 'pb_solving':
          text += "search_icon_V2";
          break;
        case 'auto_efficient':
          text = "glasses_icon_V2";
          break;
        case 'active_listen':
          text += "improve_icon_V2";
          break;
        case 'empathy':
          text += "chat-check_icon_V2";
          break;
        case 'time_manage':
          text = "heart-hexagon_icon_V2";
          break;
        case 'planning':
          text += "funnel_icon_V2";
          break;
        case 'decisions':
          text += "improve_icon_V2";
          break;
        default:
          break;
      }
      return text;
    },
    getAvantageIcon3() {
      var text = "";
      switch (this.skill) {
        case 'stress_manage':
          text = "document_icon_V2";
          break;
        case 'adaptability':
          text += "rain-cloud_icon_V2";
          break;
        case 'pb_solving':
          text += "puzzle_icon_V2";
          break;
        case 'auto_efficient':
          text = "sparkles_icon_V2";
          break;
        case 'active_listen':
          text += "document-search__icon_V2";
          break;
        case 'empathy':
          text += "cloudy_icon_V2";
          break;
        case 'time_manage':
          text = "target_icon_V2";
          break;
        case 'planning':
          text += "chart_icon_V2";
          break;
        case 'decisions':
          text += "improve_icon_V2";
          break;
        default:
          break;
      }
      return text;
    },
    getGradeColour() {
      var iconClass = " ";
      switch (this.position) {
        case '1':
          iconClass += "or-gradient";
          break;
        case '2':
          iconClass += "argent-gradient";
          break;
        case '3':
          iconClass += "bronze-gradient";
          break;
        default:
          break;
      }
      return iconClass;
    }
  }
};
</script>